import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form } from '@weezevent/nacre';

export default function PartnerBatchBookingsInfos({ onChange, onCardDone, name, countBatch }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Field>
                <Form.Label label={t('ticket.partners.batch.infos.label')} />
                <Form.Input
                    name="name"
                    placeholder={t('ticket.partners.batch.infos.placeholder', { countBatch: Number(countBatch) + 1 })}
                    value={name}
                    onChange={({ target: { value } }) => {
                        if (value.length >= 80) {
                            // max lenght of name
                            return;
                        }
                        onChange(value);
                    }}
                />
            </Form.Field>
            <Button primary label={t('ticket.common.action.continue')} onClick={onCardDone} disabled={name?.length === 0} />
        </>
    );
}

PartnerBatchBookingsInfos.propTypes = {
    onChange: PropTypes.func.isRequired,
    onCardDone: PropTypes.func,
    name: PropTypes.string.isRequired,
    countBatch: PropTypes.number.isRequired
};
